(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["blackland-reviews"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('blackland-review-showcase')) {
    customElements.define('blackland-review-showcase', class extends HTMLElement {
      connectedCallback() {
        this.events?.abort();
        this.events = new AbortController();
        this.addEventListener('click', event => this.navigate(event), { capture: true, signal: this.events.signal });
        this.mutations = new MutationObserver(() => this.updateCards());
        this.mutations.observe(this, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-review-id'] });
        this.resize = new ResizeObserver(() => this.alignCards());
        this.updateCards();
      }

      disconnectedCallback() {
        this.events?.abort();
        this.mutations?.disconnect();
        this.resize?.disconnect();
        this.visibility?.disconnect();
        this.readiness?.disconnect();
        this.activeChanges?.disconnect();
        this.wrapper = null;
        this.track = null;
        cancelAnimationFrame(this.frame);
        cancelAnimationFrame(this.transitionFrame);
      }

      updateCards() {
        const carousel = this.querySelector('.jdgm-cards-carousel');
        const wrapper = carousel?.querySelector('.jdgm-cards-wrapper');
        if (!wrapper) {
          this.dataset.reviewCount = '0';
          this.dataset.navigation = 'false';
          return;
        }
        const cards = [...wrapper.querySelectorAll('.jdgm-card[data-review-id]')];
        const track = wrapper.querySelector('.jdgm-videos-container');
        if (this.track !== track) {
          this.readiness?.disconnect();
          this.activeChanges?.disconnect();
          this.track = track;
          if (track) {
            this.activeChanges = new MutationObserver(() => this.updateNavigation());
            this.activeChanges.observe(track, { subtree: true, attributes: true, attributeFilter: ['class'] });
          }
          this.trackReady = Boolean(track?.style.transform);
          if (track && !this.trackReady) {
            this.readiness = new MutationObserver(() => {
              if (!track.style.transform) return;
              this.trackReady = true;
              this.readiness.disconnect();
              this.alignCards();
            });
            this.readiness.observe(track, { attributes: true, attributeFilter: ['style'] });
          }
        }
        const count = new Set(cards.filter(card => !card.hasAttribute('data-clone-type')).map(card => card.dataset.reviewId)).size;
        if (this.dataset.reviewCount !== String(count)) this.dataset.reviewCount = String(count);
        if (this.wrapper !== wrapper) {
          this.resize.disconnect();
          this.visibility?.disconnect();
          this.wrapper = wrapper;
          this.resize.observe(wrapper);
          this.visibility = new IntersectionObserver(entries => {
            for (const entry of entries) {
              const visible = entry.intersectionRatio > 0.5;
              entry.target.setAttribute('aria-hidden', String(!visible));
              entry.target.querySelectorAll('a, button').forEach(control => control.tabIndex = visible ? 0 : -1);
            }
          }, { root: wrapper, threshold: [0, 0.5, 1] });
        }
        for (const card of cards) {
          if (!card.querySelector('.bl-review-full')) {
            const button = document.createElement('button');
            button.type = 'button';
            button.className = 'bl-review-full';
            button.textContent = this.dataset.fullReviewLabel;
            button.tabIndex = -1;
            card.append(button);
          }
          this.visibility.observe(card);
        }
        this.alignCards();
      }

      navigationState() {
        const carousel = this.querySelector('.jdgm-cards-carousel');
        const cards = [...(this.track?.querySelectorAll('.jdgm-card[data-review-id]:not([data-clone-type])') || [])];
        const visible = Math.max(1, Math.floor(Number.parseFloat(carousel && getComputedStyle(carousel).getPropertyValue('--visible-cards')) || 1));
        return { carousel, cards, visible, current: cards.findIndex(card => card.classList.contains('active')), last: Math.max(0, cards.length - visible) };
      }

      moveTo(state, target) {
        const step = target > state.current ? window.jdgmNextCard : window.jdgmPreviousCard;
        const blockId = state.carousel?.dataset.jdgmBlockId;
        if (state.current < 0 || !blockId || typeof step !== 'function') return false;
        for (let index = 0; index < Math.abs(target - state.current); index++) step(blockId);
        return true;
      }

      navigate(event) {
        const arrow = event.target.closest('.jdgm-content > .jdgm-arrow');
        if (!arrow) return;
        const state = this.navigationState();
        if (arrow.closest('.jdgm-cards-carousel') !== state.carousel || state.current < 0 || !this.trackReady) return;
        const arrows = [...state.carousel.querySelectorAll('.jdgm-content > .jdgm-arrow')];
        if (arrows.length !== 2 || !arrows.includes(arrow)) return;
        const previous = arrow === arrows[0];
        const target = previous
          ? Math.max(0, Math.min(state.last, (Math.ceil(state.current / state.visible) - 1) * state.visible))
          : state.current >= state.last ? state.current : Math.min(state.last, (Math.floor(state.current / state.visible) + 1) * state.visible);
        if (!this.moveTo(state, target)) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        this.updateNavigation();
      }

      updateNavigation() {
        const state = this.navigationState();
        this.dataset.navigation = String(state.cards.length > state.visible);
        const arrows = state.carousel?.querySelectorAll('.jdgm-content > .jdgm-arrow');
        arrows?.[0]?.setAttribute('aria-disabled', String(state.current <= 0));
        arrows?.[1]?.setAttribute('aria-disabled', String(state.current < 0 || state.current >= state.last));
      }

      alignCards() {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => {
          const carousel = this.querySelector('.jdgm-cards-carousel');
          const track = this.wrapper?.querySelector('.jdgm-videos-container');
          const state = this.navigationState();
          if (state.current > state.last) this.moveTo(state, state.last);
          this.updateNavigation();
          const active = track?.querySelector('.active:not([data-clone-type])');
          if (!carousel || !active || !this.trackReady) return;
          const offset = this.wrapper.getBoundingClientRect().left - active.getBoundingClientRect().left;
          if (Math.abs(offset) < 1) return;
          const transform = new DOMMatrixReadOnly(getComputedStyle(track).transform);
          track.style.transition = 'none';
          track.style.transform = `translateX(${transform.m41 + offset}px)`;
          cancelAnimationFrame(this.transitionFrame);
          this.transitionFrame = requestAnimationFrame(() => track.style.removeProperty('transition'));
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
